import Menu from '@blocks/navigation/menu'
import { SanityHeaderSettings } from '@data/sanity/queries/types/site'
import { LayoutContext, UIContext } from '@lib/site-context'
import cx from 'classnames'
import { motion } from 'framer-motion'
import { useContext } from 'react'

type MobileMenuProps = Pick<
  SanityHeaderSettings,
  'menuMobilePrimary' | 'menuMobileSecondary'
>

const MobileMenu = ({
  menuMobilePrimary,
  menuMobileSecondary,
}: MobileMenuProps) => {
  const { headerHeight, promoVisibleHeight } = useContext(LayoutContext)
  const { mobileMenu, toggleMobileMenu } = useContext(UIContext)

  return (
    <nav id="mobile-nav" className="lg:hidden flex justify-end items-center">
      <div className="flex items-center">
        <motion.div
          initial="hide"
          animate={mobileMenu.isOpen ? 'show' : 'hide'}
          variants={{
            show: {
              x: '0%',
            },
            hide: {
              x: '-100%',
            },
          }}
          transition={{
            duration: 0.8,
            ease: [0.16, 1, 0.3, 1],
          }}
          className="fixed top-0 left-0 w-full h-screen z-50 flex flex-col bg-pageBG text-pageText"
        >
          <div
            className="flex-1 flex flex-col justify-between gap-y-16 px-4 pb-40 overflow-y-scroll no-scrollbar"
            style={{
              paddingTop: headerHeight + promoVisibleHeight + 24,
            }}
          >
            {!!menuMobilePrimary?.items && (
              <Menu
                id={menuMobilePrimary.slug.current}
                items={menuMobilePrimary.items}
                onClick={() => toggleMobileMenu(false)}
                isHeaderMobilePrimaryMenu
              />
            )}

            {!!menuMobileSecondary?.items && (
              <Menu
                id={menuMobileSecondary.slug.current}
                items={menuMobileSecondary.items}
                onClick={() => toggleMobileMenu(false)}
                isHeaderMobileSecondaryMenu
              />
            )}
          </div>
        </motion.div>

        <div
          className={cx(
            'fixed inset-0 z-40 bg-backdrop bg-opacity-40 pointer-events-none transition-opacity duration-150 ease-linear',
            {
              'opacity-0': !mobileMenu.isOpen,
              'pointer-events-auto opacity-100': mobileMenu.isOpen,
            },
          )}
          onClick={() => toggleMobileMenu(false)}
          role="presentation"
        />
      </div>
    </nav>
  )
}

export default MobileMenu
